export const ChartData = {
  //--------------- Fuel Dashboard 4 small chart inside modal -----------------------
  fuelConsumption: [
    { date: '2023-04-01', 'MovingFuelUsage': 39, 'GlobalAvgConsumption': 37 },
    { date: '2023-04-02', 'MovingFuelUsage': 37, 'GlobalAvgConsumption': 35 },
    { date: '2023-04-03', 'MovingFuelUsage': 36, 'GlobalAvgConsumption': 34 },
    { date: '2023-04-04', 'MovingFuelUsage': 37, 'GlobalAvgConsumption': 35 },
    { date: '2023-04-05', 'MovingFuelUsage': 34, 'GlobalAvgConsumption': 32 },
    { date: '2023-04-06', 'MovingFuelUsage': 34, 'GlobalAvgConsumption': 32 },
    { date: '2023-04-07', 'MovingFuelUsage': 35, 'GlobalAvgConsumption': 33 },
    { date: '2023-04-08', 'MovingFuelUsage': 42, 'GlobalAvgConsumption': 40 },
    { date: '2023-04-09', 'MovingFuelUsage': 42, 'GlobalAvgConsumption': 40 },
    { date: '2023-04-10', 'MovingFuelUsage': 42, 'GlobalAvgConsumption': 40 },
    { date: '2023-04-11', 'MovingFuelUsage': 43, 'GlobalAvgConsumption': 41 },
    { date: '2023-04-12', 'MovingFuelUsage': 43, 'GlobalAvgConsumption': 41 },
    { date: '2023-04-13', 'MovingFuelUsage': 44, 'GlobalAvgConsumption': 42 },
    { date: '2023-04-14', 'MovingFuelUsage': 42, 'GlobalAvgConsumption': 40 },
    { date: '2023-04-15', 'MovingFuelUsage': 44, 'GlobalAvgConsumption': 42 },
    { date: '2023-04-16', 'MovingFuelUsage': 43, 'GlobalAvgConsumption': 41 },
    { date: '2023-04-17', 'MovingFuelUsage': 40, 'GlobalAvgConsumption': 39 },
    { date: '2023-04-18', 'MovingFuelUsage': 39, 'GlobalAvgConsumption': 37 },
    { date: '2023-04-19', 'MovingFuelUsage': 38, 'GlobalAvgConsumption': 36 },
    { date: '2023-04-20', 'MovingFuelUsage': 39, 'GlobalAvgConsumption': 37 },
    { date: '2023-04-21', 'MovingFuelUsage': 38, 'GlobalAvgConsumption': 36 },
    { date: '2023-04-22', 'MovingFuelUsage': 50, 'GlobalAvgConsumption': 48 },
  ],
  fuelConsumptionLineConfig: [
    {
      key: 'MovingFuelUsage',
      label: 'Usage',
      color: '#FF7F00', // Example color (red/pink)
      legend: 'Moving Fuel Usage (%)'
    },
    {
      key: 'GlobalAvgConsumption',
      label: 'Avg',
      color: '#3873C9', // Example color (blue)
      legend: 'Global Avg Consumption'
    }
  ],


  fuelCost: [
    { date: '2025-04-01', overallUsedFuelCost: 21.6, globalAvgFuelCost: 21.4 },
    { date: '2025-04-07', overallUsedFuelCost: 22.4, globalAvgFuelCost: 22.2 },
    { date: '2025-04-14', overallUsedFuelCost: 22.4, globalAvgFuelCost: 22.2 },
    { date: '2025-04-22', overallUsedFuelCost: 22.4, globalAvgFuelCost: 22.2 }
  ],
  fuelCostThree: [
    { date: 'Mon', overallUsedFuelCost: 44, globalAvgFuelCost: 6 },
    { date: 'Tue', overallUsedFuelCost: 33, globalAvgFuelCost: 3 },
    { date: 'Wed', overallUsedFuelCost: 36, globalAvgFuelCost: 4 },
    { date: 'Thu', overallUsedFuelCost: 29, globalAvgFuelCost: 2 },
    { date: 'Fri', overallUsedFuelCost: 34, globalAvgFuelCost: 3.5 },
    { date: 'Sat', overallUsedFuelCost: 38, globalAvgFuelCost: 4.5 },
    { date: 'Sun', overallUsedFuelCost: 41, globalAvgFuelCost: 6 }
  ],
  fuelCostTw: [
    { date: '2025-04-01', overallUsedFuelCost: 21.6, globalAvgFuelCost: 21.4 },
    { date: '2025-04-02', overallUsedFuelCost: 21.6, globalAvgFuelCost: 21.4 },
    { date: '2025-04-03', overallUsedFuelCost: 21.6, globalAvgFuelCost: 21.4 },
    { date: '2025-04-04', overallUsedFuelCost: 21.6, globalAvgFuelCost: 21.4 },
    { date: '2025-04-05', overallUsedFuelCost: 22.0, globalAvgFuelCost: 21.4 },
    { date: '2025-04-06', overallUsedFuelCost: 22.4, globalAvgFuelCost: 21.8 },
    { date: '2025-04-07', overallUsedFuelCost: 22.4, globalAvgFuelCost: 22.2 },
    { date: '2025-04-08', overallUsedFuelCost: 22.4, globalAvgFuelCost: 22.2 },
    { date: '2025-04-09', overallUsedFuelCost: 22.4, globalAvgFuelCost: 22.2 },
    { date: '2025-04-10', overallUsedFuelCost: 22.4, globalAvgFuelCost: 22.2 },
    { date: '2025-04-11', overallUsedFuelCost: 22.4, globalAvgFuelCost: 22.2 },
    { date: '2025-04-12', overallUsedFuelCost: 22.4, globalAvgFuelCost: 22.2 },
    { date: '2025-04-13', overallUsedFuelCost: 22.4, globalAvgFuelCost: 22.2 },
    { date: '2025-04-14', overallUsedFuelCost: 22.4, globalAvgFuelCost: 22.2 },
    { date: '2025-04-15', overallUsedFuelCost: 22.4, globalAvgFuelCost: 22.2 },
    { date: '2025-04-16', overallUsedFuelCost: 22.4, globalAvgFuelCost: 22.2 },
    { date: '2025-04-17', overallUsedFuelCost: 22.4, globalAvgFuelCost: 22.2 },
    { date: '2025-04-18', overallUsedFuelCost: 22.4, globalAvgFuelCost: 22.2 },
    { date: '2025-04-19', overallUsedFuelCost: 22.4, globalAvgFuelCost: 22.2 },
    { date: '2025-04-20', overallUsedFuelCost: 22.4, globalAvgFuelCost: 22.2 },
    { date: '2025-04-21', overallUsedFuelCost: 22.4, globalAvgFuelCost: 22.2 },
    { date: '2025-04-22', overallUsedFuelCost: 22.4, globalAvgFuelCost: 22.2 },
  ],

  fuelCostConfig: [
    {
      key: 'overallUsedFuelCost',
      label: 'Overal',
      color: '#FF7F00', // Example color (red/pink)
      legend: 'Overall used fuel cost'
    },
    {
      key: 'globalAvgFuelCost',
      label: 'Actual',
      color: '#3873C9', // Example color (blue)
      legend: 'Global avg cost of fuel R/ℓ'
    }
  ],


  totalDecrease: [
    { label: 'Week 1', 'Unusual': 45, 'Driving': 30, 'Idling': 5 },
    { label: 'Week 2', 'Unusual': 50, 'Driving': 40, 'Idling': 2 },
    { label: 'Week 3', 'Unusual': 28, 'Driving': 40, 'Idling': 1 },
    { label: 'Week 4', 'Unusual': 20, 'Driving': 35, 'Idling': 1 },
  ],
  totalDecreaseBig: [
    { label: 'Jan', 'Unusual': 48, 'Driving': 30, 'Idling': 8 },
    { label: 'Feb', 'Unusual': 30, 'Driving': 20, 'Idling': 3 },
    { label: 'Mar', 'Unusual': 30, 'Driving': 20, 'Idling': 4 },
    { label: 'Apr', 'Unusual': 48, 'Driving': 20, 'Idling': 6 },
    { label: 'May', 'Unusual': 63, 'Driving': 20, 'Idling': 5 },
    { label: 'Jun', 'Unusual': 44, 'Driving': 53, 'Idling': 2 },
    { label: 'Jul', 'Unusual': 35, 'Driving': 18, 'Idling': 3 },
    { label: 'Aug', 'Unusual': 44, 'Driving': 55, 'Idling': 2 },
    { label: 'Sep', 'Unusual': 52, 'Driving': 19, 'Idling': 3 },
    { label: 'Oct', 'Unusual': 29, 'Driving': 20, 'Idling': 3 },
    { label: 'Nov', 'Unusual': 37, 'Driving': 19, 'Idling': 5 },
    { label: 'Dec', 'Unusual': 30, 'Driving': 19, 'Idling': 2 },
  ],


  //--------------- Fuel Dashboard 4 chart card -------------------

  movingVsIdleTime: [
    { week: 'Week 1', idle: 80, moving: 150, globaltrend: 170 },
    { week: 'Week 2', idle: 70, moving: 230, globaltrend: 250 },
    { week: 'Week 3', idle: 92, moving: 190, globaltrend: 300 },
    { week: 'Week 4', idle: 50, moving: 140, globaltrend: 190 },
  ],

  distanceDriven: [
    { "date": "2023-04-01", "driven": 750, "avgTrip": 740 },
    { "date": "2023-04-02", "driven": 765, "avgTrip": 760 },
    { "date": "2023-04-03", "driven": 800, "avgTrip": 780 },
    { "date": "2023-04-04", "driven": 820, "avgTrip": 810 },
    { "date": "2023-04-05", "driven": 790, "avgTrip": 825 },
    { "date": "2023-04-06", "driven": 870, "avgTrip": 860 },
    { "date": "2023-04-07", "driven": 890, "avgTrip": 880 },
    { "date": "2023-04-08", "driven": 910, "avgTrip": 900 },
    { "date": "2023-04-09", "driven": 850, "avgTrip": 850 },
    { "date": "2023-04-10", "driven": 780, "avgTrip": 770 },
    { "date": "2023-04-11", "driven": 730, "avgTrip": 740 },
    { "date": "2023-04-12", "driven": 690, "avgTrip": 690 },
    { "date": "2023-04-13", "driven": 720, "avgTrip": 650 },
    { "date": "2023-04-14", "driven": 760, "avgTrip": 620 },
    { "date": "2023-04-15", "driven": 800, "avgTrip": 550 },
    { "date": "2023-04-16", "driven": 790, "avgTrip": 400 },
    { "date": "2023-04-17", "driven": 810, "avgTrip": 300 },
    { "date": "2023-04-18", "driven": 820, "avgTrip": 420 },
    { "date": "2023-04-19", "driven": 830, "avgTrip": 380 },
    { "date": "2023-04-20", "driven": 800, "avgTrip": 650 },
    { "date": "2023-04-21", "driven": 820, "avgTrip": 670 },
    { "date": "2023-04-22", "driven": 810, "avgTrip": 690 }
  ],
  distanceDrivenConfig: [
    { key: 'avgTrip', label: 'Avg km/trip', color: '#EE2737', legend: 'Km driven per day' },
    { key: 'driven', label: 'Km driven/day', color: '#3873C9', legend: 'Average km per trip' },
  ],

  fillUpFrequency: [
    { week: 'Week 1', avgVolume: 120, totalVolume: 80, fillUp: 70 },
    { week: 'Week 2', avgVolume: 80, totalVolume: 100, fillUp: 120 },
    { week: 'Week 3', avgVolume: 80, totalVolume: 100, fillUp: 100 },
    { week: 'Week 4', avgVolume: 40, totalVolume: 100, fillUp: 70 },
  ],




  movingVsIdleTimeBigData: [
    { week: '01 Apr', idle: 5, moving: 30, globaltrend: 78 },
    { week: '02 Apr', idle: 5, moving: 95, globaltrend: 80 },
    { week: '03 Apr', idle: 6, moving: 87, globaltrend: 82 },
    { week: '04 Apr', idle: 5, moving: 54, globaltrend: 85 },
    { week: '05 Apr', idle: 5, moving: 95, globaltrend: 88 },
    { week: '06 Apr', idle: 5, moving: 88, globaltrend: 90 },
    { week: '07 Apr', idle: 5, moving: 95, globaltrend: 92 },
    { week: '08 Apr', idle: 5, moving: 87, globaltrend: 93 },
    { week: '09 Apr', idle: 6, moving: 35, globaltrend: 95 },
    { week: '10 Apr', idle: 5, moving: 94, globaltrend: 96 },
    { week: '11 Apr', idle: 5, moving: 87, globaltrend: 98 },
    { week: '12 Apr', idle: 5, moving: 62, globaltrend: 99 },
    { week: '13 Apr', idle: 5, moving: 35, globaltrend: 100 },
    { week: '14 Apr', idle: 5, moving: 95, globaltrend: 98 },
    { week: '15 Apr', idle: 5, moving: 87, globaltrend: 95 },
    { week: '16 Apr', idle: 5, moving: 55, globaltrend: 93 },
    { week: '17 Apr', idle: 5, moving: 38, globaltrend: 91 },
    { week: '18 Apr', idle: 5, moving: 94, globaltrend: 90 },
    { week: '19 Apr', idle: 5, moving: 88, globaltrend: 88 },
    { week: '20 Apr', idle: 5, moving: 90, globaltrend: 86 },
    { week: '21 Apr', idle: 5, moving: 91, globaltrend: 84 },
    { week: '22 Apr', idle: 5, moving: 65, globaltrend: 82 }
  ],

  fillUpFrequencyBigData: [
    { week: '01 Apr', fillUp: 20, totalVolume: 20, avgVolume: 60 },
    { week: '02 Apr', fillUp: 20, totalVolume: 30, avgVolume: 50 },
    { week: '03 Apr', fillUp: 20, totalVolume: 30, avgVolume: 40 },
    { week: '04 Apr', fillUp: 10, totalVolume: 20, avgVolume: 30 },
    { week: '05 Apr', fillUp: 20, totalVolume: 30, avgVolume: 50 },
    { week: '06 Apr', fillUp: 20, totalVolume: 30, avgVolume: 40 },
    { week: '07 Apr', fillUp: 20, totalVolume: 30, avgVolume: 40 },
    { week: '08 Apr', fillUp: 10, totalVolume: 20, avgVolume: 30 },
    { week: '09 Apr', fillUp: 10, totalVolume: 20, avgVolume: 20 },
    { week: '10 Apr', fillUp: 20, totalVolume: 30, avgVolume: 50 },
    { week: '11 Apr', fillUp: 20, totalVolume: 30, avgVolume: 30 },
    { week: '12 Apr', fillUp: 10, totalVolume: 20, avgVolume: 20 },
    { week: '13 Apr', fillUp: 20, totalVolume: 30, avgVolume: 50 },
    { week: '14 Apr', fillUp: 20, totalVolume: 30, avgVolume: 40 },
    { week: '15 Apr', fillUp: 10, totalVolume: 20, avgVolume: 30 },
    { week: '16 Apr', fillUp: 10, totalVolume: 20, avgVolume: 20 },
    { week: '17 Apr', fillUp: 20, totalVolume: 30, avgVolume: 50 },
    { week: '18 Apr', fillUp: 20, totalVolume: 30, avgVolume: 40 },
    { week: '19 Apr', fillUp: 10, totalVolume: 20, avgVolume: 30 },
    { week: '20 Apr', fillUp: 20, totalVolume: 30, avgVolume: 50 },
    { week: '21 Apr', fillUp: 20, totalVolume: 30, avgVolume: 40 },
    { week: '22 Apr', fillUp: 10, totalVolume: 20, avgVolume: 30 },
  ],

  fuelConsumptionBig: [
    { date: '2023-04-01', 'MovingFuelUsage': 39, 'GlobalAvgConsumption': 37 },
    { date: '2023-04-02', 'MovingFuelUsage': 37, 'GlobalAvgConsumption': 35 },
    { date: '2023-04-03', 'MovingFuelUsage': 36, 'GlobalAvgConsumption': 34 },
    { date: '2023-04-04', 'MovingFuelUsage': 37, 'GlobalAvgConsumption': 35 },
    { date: '2023-04-05', 'MovingFuelUsage': 34, 'GlobalAvgConsumption': 32 },
    { date: '2023-04-06', 'MovingFuelUsage': 34, 'GlobalAvgConsumption': 32 },
    { date: '2023-04-07', 'MovingFuelUsage': 35, 'GlobalAvgConsumption': 33 },
    { date: '2023-04-08', 'MovingFuelUsage': 42, 'GlobalAvgConsumption': 40 },
    { date: '2023-04-09', 'MovingFuelUsage': 42, 'GlobalAvgConsumption': 40 },
    { date: '2023-04-10', 'MovingFuelUsage': 42, 'GlobalAvgConsumption': 40 },
    { date: '2023-04-11', 'MovingFuelUsage': 43, 'GlobalAvgConsumption': 41 },
    { date: '2023-04-12', 'MovingFuelUsage': 43, 'GlobalAvgConsumption': 41 },
    { date: '2023-04-13', 'MovingFuelUsage': 44, 'GlobalAvgConsumption': 42 },
    { date: '2023-04-14', 'MovingFuelUsage': 42, 'GlobalAvgConsumption': 40 },
    { date: '2023-04-15', 'MovingFuelUsage': 44, 'GlobalAvgConsumption': 42 },
    { date: '2023-04-16', 'MovingFuelUsage': 43, 'GlobalAvgConsumption': 41 },
    { date: '2023-04-17', 'MovingFuelUsage': 40, 'GlobalAvgConsumption': 39 },
    { date: '2023-04-18', 'MovingFuelUsage': 39, 'GlobalAvgConsumption': 37 },
    { date: '2023-04-19', 'MovingFuelUsage': 38, 'GlobalAvgConsumption': 36 },
    { date: '2023-04-20', 'MovingFuelUsage': 39, 'GlobalAvgConsumption': 37 },
    { date: '2023-04-21', 'MovingFuelUsage': 38, 'GlobalAvgConsumption': 36 },
    { date: '2023-04-22', 'MovingFuelUsage': 50, 'GlobalAvgConsumption': 48 },
  ],

  accelerationBraking: [
    { label: 'Speeding', you: 350, globaltrend: 500 },
    { label: 'Harsh Breaking', you: 100, globaltrend: 500 },
    { label: 'Harsh Acceleration', you: 350, globaltrend: 500 },
    { label: 'Harsh Cornering', you: 220, globaltrend: 330 },
  ],

  reconciliationVariate: [
    { label: 'Week 1', 'Bought': 50, 'Detected': 45 },
    { label: 'Week 2', 'Bought': 60, 'Detected': 56 },
    { label: 'Week 3', 'Bought': 90, 'Detected': 85 },
    { label: 'Week 4', 'Bought': 100, 'Detected': 90 },
  ],

  reconciliationVariateBig: [
    { week: '01 Apr', 'Bought': 100, 'Detected': 97 },
    { week: '02 Apr', 'Bought': 50, 'Detected': 45 },
    { week: '03 Apr', 'Bought': 90, 'Detected': 85 },
    { week: '04 Apr', 'Bought': 45, 'Detected': 44 },
    { week: '05 Apr', 'Bought': 46, 'Detected': 44 },
    { week: '06 Apr', 'Bought': 60, 'Detected': 60 },
    { week: '07 Apr', 'Bought': 60, 'Detected': 60 },
    { week: '08 Apr', 'Bought': 100, 'Detected': 96 },
    { week: '09 Apr', 'Bought': 50, 'Detected': 35 },
    { week: '10 Apr', 'Bought': 50, 'Detected': 30 },
    { week: '11 Apr', 'Bought': 50, 'Detected': 30 },
    { week: '12 Apr', 'Bought': 50, 'Detected': 45 },
    { week: '13 Apr', 'Bought': 90, 'Detected': 85 },
    { week: '14 Apr', 'Bought': 90, 'Detected': 85 },
    { week: '15 Apr', 'Bought': 90, 'Detected': 85 },
    { week: '16 Apr', 'Bought': 85, 'Detected': 75 },
    { week: '17 Apr', 'Bought': 70, 'Detected': 65 },
    { week: '18 Apr', 'Bought': 70, 'Detected': 65 },
    { week: '19 Apr', 'Bought': 70, 'Detected': 65 },
    { week: '20 Apr', 'Bought': 100, 'Detected': 98 },
    { week: '21 Apr', 'Bought': 60, 'Detected': 60 },
    { week: '22 Apr', 'Bought': 100, 'Detected': 96 },
  ]
}

